'use client'

import React, { use } from 'react'
import { useBarcode } from '@/lib/hooks'

import { RefContext, type Refs } from '@/components/providers/ref-provider'

export function BarcodeReader() {
  const { barcodeInputRef, barcodeFormRef } = use(RefContext) as Refs
  const { submitBarcodeProduct } = useBarcode()

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  React.useEffect(() => {
    barcodeInputRef?.current?.focus()
  }, [])

  return (
    <form
      ref={barcodeFormRef}
      action={submitBarcodeProduct}
      className="absolute opacity-0"
    >
      <input ref={barcodeInputRef} name="barcode-value" type="text" />
    </form>
  )
}
